import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import CheckCSName from "../CheckCSName";
import EmptyLine from "../EmptyLine";
import {useUser} from "../../../context/UserContext";
import ResultView from "../../../components/ResultView";

export function B15({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}
const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.XY10.error_id: {
            return (
                <>
                    <ResultText>
                        The cross-section cutlines of the following {row?.data?.length} cross sections intersect with other cross sections.
                        <EmptyLine />
                        <CheckCSName csNameList={row?.data?.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}